import { render } from "./DefaultOverlay.vue?vue&type=template&id=6aa18d7a&scoped=true"
import script from "./DefaultOverlay.vue?vue&type=script&lang=js"
export * from "./DefaultOverlay.vue?vue&type=script&lang=js"

import "./DefaultOverlay.vue?vue&type=style&index=0&id=6aa18d7a&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6aa18d7a"]])

export default __exports__